import {
  ExcelDriverTemplateGenerationResponse,
  ExcelDriverUploadResponse,
  ExcelDriverValidationFailureResponse,
  ExcelDriverValidationSuccessResponse
} from '@futrli-sdk/predict';
import { API_PATHS, APIClients, interpolatePathParams, REQUEST_METHODS, ROUTE_PARAMS } from '@futrli/shared-services';
import { makeRequestWithResponse } from './shared';

/**
 * Get excel file validation status
 *
 * @param {string} workspaceId - related workspace
 * @param {string} excelId - related excel ID
 * @returns {Promise<{ excel_id: string; validation_status: string; error_details: ExcelDriverValidationFailureResponse | null; }>} - Returns
 * @throws error
 */
export const getExcelFileValidation = async (
  workspaceId: string,
  organisationId: string,
  excelId: string
): Promise<
  | ExcelDriverValidationFailureResponse
  | ExcelDriverValidationSuccessResponse
  | {
      excel_id: string;
      validation_status: string;
    }
> => {
  const url = interpolatePathParams(API_PATHS.EXCEL_DRIVER_FILE_VALIDATION, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.EXCEL_ID]: excelId
  });
  const response = await APIClients.getAPIClient().makeRequest({
    validateStatus: () => true,
    payload: {
      request: {
        method: REQUEST_METHODS.POST,
        url
      }
    }
  });
  return (response.data as unknown) as
    | ExcelDriverValidationFailureResponse
    | {
        excel_id: string;
        validation_status: string;
      };
};

/**
 * Upload drivers from excel file to populate driver data
 *
 * @param {string} workspaceId - related workspace
 * @param {string} excelId - related excelId
 * @param {string} organisationId - related organisationId
 * @returns {Promise<ExcelDriverUploadResponse>}
 * @throws error
 */
export const generateDriver = async (
  workspaceId: string,
  organisationId: string,
  excelId: string
): Promise<ExcelDriverUploadResponse> => {
  const url = interpolatePathParams(API_PATHS.EXCEL_DRIVER_UPLOAD, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.EXCEL_ID]: excelId
  });

  return makeRequestWithResponse<ExcelDriverUploadResponse>({
    url,
    method: REQUEST_METHODS.POST
  });
};

/**
 * Generate driver excel template
 *
 * @param {string} workspaceId - related workspace
 * @param {string} organisationId - related organisationId
 * @returns {Promise<ExcelDriverTemplateGenerationResponse>}
 * @throws error
 */
export const generateDriverTemplate = async (
  workspaceId: string,
  organisationId: string
): Promise<ExcelDriverTemplateGenerationResponse> => {
  const url = interpolatePathParams(API_PATHS.GENERATE_DRIVER_TEMPLATE, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId
  });

  return makeRequestWithResponse<ExcelDriverTemplateGenerationResponse>({
    url,
    method: REQUEST_METHODS.POST
  });
};
